import { useCallback } from "react";
import { useAuth } from "@clerk/react";
import { makeApi } from "@/lib/api";
import { playExclusive, stopActive } from "@/components/SpeakButton";

const urls = new Map();

const browserSpeak = (text, voice) => {
  if (!window.speechSynthesis) return;
  window.speechSynthesis.cancel();
  const u = new SpeechSynthesisUtterance(text);
  u.lang = voice;
  u.rate = 0.85;
  window.speechSynthesis.speak(u);
};

export default function useMascotSpeak() {
  const { getToken, isSignedIn } = useAuth();
  return useCallback(async (text, lang, mascot, browserVoice) => {
    stopActive();
    window.speechSynthesis?.cancel();
    if (!isSignedIn) { browserSpeak(text, browserVoice); return; }
    const key = `${mascot}|${lang}|${text}`;
    try {
      if (!urls.has(key)) {
        const r = await makeApi(getToken).post("/voice", { mascot, text, lang }, { responseType: "blob", timeout: 60000 });
        urls.set(key, URL.createObjectURL(r.data));
      }
      await playExclusive(new Audio(urls.get(key)), "lang");
    } catch {
      browserSpeak(text, browserVoice);
    }
  }, [getToken, isSignedIn]);
}
